import styled from "styled-components";

export const HamburgerNav = styled.div`
  display: flex;
  flex-direction: column;

  &:hover {
    cursor: pointer;
  }
`;

export const HamburgerSpan = styled.span`
  border: solid 4px white;
  margin: 0.2rem 0;
  width: 5.5rem;
  border-radius: 2px;

  &:nth-of-type(1) {
    width: 4rem;
    margin-left: auto;
  }
`;
